module.exports = __webpack_public_path__ + "static/media/chips.062b2673.jpg";